import { defineStore } from 'pinia'

interface UIState {
  // Loading state with ref counting for concurrent requests
  loadingCount: number
  // Modals
  showUpgradeModal: boolean
}

export const useUIStore = defineStore('ui', {
  state: (): UIState => ({
    loadingCount: 0,
    showUpgradeModal: false
  }),

  getters: {
    isLoading: (state): boolean => state.loadingCount > 0
  },

  actions: {
    // Loading actions
    startLoading(): void {
      this.loadingCount++
    },

    stopLoading(): void {
      this.loadingCount = Math.max(0, this.loadingCount - 1)
    },

    // Upgrade modal actions
    openUpgradeModal(): void {
      this.showUpgradeModal = true
    },

    closeUpgradeModal(): void {
      this.showUpgradeModal = false
    }
  }
})
